
import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import StaffPositionsListView from "./staff_positions-list.html";
import StaffPositionsEditView from "./staff_positions-edit.html";

angular.module("staff_positions", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('staff_positions', {
                url: "/staff_positions",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('staff_positions.list', {
                url: "/list",
                controller: "StaffPositionsListCtrl",
                template: StaffPositionsListView,
                requiredPermission: ["STAFF_POSITION_READ"]
            })            
            .state('staff_positions.edit', {
                url: "/edit/:id",
                controller: "StaffPositionsEditCtrl",
                template: StaffPositionsEditView,
                requiredPermission: ["STAFF_POSITION_READ"]
            })
    }])
;